module.exports = __webpack_public_path__ + "static/media/image-modal-email.3d51c666.svg";